import Vue from 'vue'
import Vuex from 'vuex'
Vue.config.devtools = true
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    // Internal field names of the columns we want returned.
    // Covers both Doc Sets and ITB files.
    lettingFields: "ContractType,ContentType,FileLeafRef,Name,ID,County,Let,Let_x0020_Date,FileRef,Division,Let_x0020_Status,Letting_x0020_Document_x0020_Type,Let_x0020_Doc_x0020_Set,Project,Title",
    lettingFieldsRoadside: "ContentType,Details_x0020_Link,FileLeafRef,Name,ID,County,Bid_x0020_Opening,FileRef,Division,Let_x0020_Status,Letting_x0020_Document_x0020_Type",
    
    // SQL-ish queries that are used by SPPlus
    lettingQuery: "(ContentType = 'Letting Project Document Set' AND Let_x0020_Status <> 'Awarded' AND Let_x0020_Status <> 'Archived' AND Let_x0020_Status <> 'Let' AND Let_x0020_Status <> '') OR (ContentType = 'Project Letting Documents' AND Letting_x0020_Document_x0020_Type = 'Invitation to Bid' OR Letting_x0020_Document_x0020_Type = 'Synopsis' AND Let_x0020_Status <> 'Awarded' AND Let_x0020_Status <> 'Archived' AND Let_x0020_Status <> 'Let')",
    lettingRoadsideQuery: "(ContentType = 'Document Set' AND Let_x0020_Status <> 'Let' AND Let_x0020_Status <> '' AND Bid_x0020_Opening <> '') OR (ContentType = 'Document' AND Letting_x0020_Document_x0020_Type = 'Invitation to Bid' AND Let_x0020_Status <> 'Let')",
  

    // Loaded Lets Live in here
    letDocSetItems: [
      {
        "UniqueId": "71E6D9BC-E5EF-43C4-8E6E-F7DA0D3D618B",
        "Pin": false,
        "id": "2649",
        "ContentType": "Letting Project Document Set",
        "FullLibraryName": "Division 3 Letting",
        "Division": "Division 3",
        "Overview": [],
        "Status": "Advertised",
        "LetDate": "2019-05-16T04:00:00Z",
        "Let": "<a class='rollup_view_link' href='Letting-Details.aspx?let_type=3&let_date=2019-05-16'>View<i class='fas fa-external-link-alt'></i></a>",
        "OpenLet": "Letting-Details.aspx?let_type=3&let_date=2019-05-16",
        "FileRef": "letting/Division%203%20Letting/05-16-2019",
        "FileLeafRef": "2649;#05-16-2019",
        "LetDocSet": "Yes",
        "Project": null,
        "Title": "05-16-2019",
        "OverViewString": ""
      },
      {
        "UniqueId": "30996331-6411-4420-BB77-DE7F99025223",
        "Pin": false,
        "id": "2089",
        "ContentType": "Letting Project Document Set",
        "FullLibraryName": "Division 4 Letting",
        "Division": "Division 4",
        "Overview": [
        ],
        "Status": "Advertised",
        "LetDate": "2019-05-28T04:00:00Z",
        "Let": "<a class='rollup_view_link' href='Letting-Details.aspx?let_type=4&let_date=2019-05-28'>View<i class='fas fa-external-link-alt'></i></a>",
        "OpenLet": "Letting-Details.aspx?let_type=4&let_date=2019-05-28",
        "FileRef": "letting/Division%204%20Letting/05-28-2019",
        "FileLeafRef": "2089;#05-28-2019",
        "LetDocSet": "Yes",
        "Project": null,
        "Title": "05-28-2019",
        "OverViewString": ""
      }],
    
    // Column criteria configured in here
    rollUpColumns: [{
      text: "UniqueId",
      field: "UniqueId",
      visible: false,
      download: false
    },
    {
      title: "★",
      field: "Pin",
      resizable: false,
      download: false,
      width: 50,
      headerSort: false,
      sorter: "boolean",
      formatter: "tickCross", formatterParams: {
        allowEmpty: true,
        allowTruthy: false,
        tickElement: "<i class='fa fa-check'></i>",
        crossElement: "<i class='fa fa-times'></i>"
      },
      cellClick: function (e, cell) {
        toggleFavorites(cell);
      },
    },
    {
      title: "Date",
      field: "LetDate",
      responsive: 0,
      width: 100,
      formatter: "datetime",
      cssClass: "column__date",
      sorterParams: {
        alignEmptyValues: "bottom",
      },
      formatterParams: {
        inputFormat: "YYYY/MM/DD",
        outputFormat: "MM/DD/YY",
        invalidPlaceholder: " -- ",
      }
    },
    {
      title: "Let By",
      field: "Division",
      responsive: 0,
      width: 120,
      cssClass: "column__type",
      formatter: "link",
      formatterParams: {
        target: "_blank",
        url: function (cell) {
          // return createDivisionLinks(cell);
        }
      }
    },
    {
      title: "Status",
      field: "Status",
      width: 120,
      cssClass: "column__status",
      formatterParams: {
        invalidPlaceholder: " -- ",
      }
    },
    {
      title: "Overview",
      field: "OverViewString",
      headerSort: false,
      formatter: 'html',
      cssClass: "column__overview",
      download: true
    },

    {
      visible: false,
      title: "Overview2",
      field: "OverViewString",
      headerSort: false,
      cssClass: "column__overview",
      formatter: function (cell) {

        if (cell._cell.row.data.Overview.length < 2) {

          return "<span>" + cell._cell.row.data.Overview + "</span>"

        } else {
          console.log('Many!')

          // var fabricCallout = '<div class="ms-Callout ms-Callout--arrowLeft ms-Callout--close is-hidden" id="lettingCallout">    '+
          // '    <div class="ms-Callout-main">                                              '+
          // '    <button class="ms-Callout-close">                                          '+
          // '        <i class="ms-Icon ms-Icon--Clear"></i>                                 '+
          // '    </button>                                                                  '+
          // '    <div class="ms-Callout-header">                                            '+
          // '        <p class="ms-Callout-title">'+ cell._cell.row.data.Title +'</p>        '+
          // '    </div>                                                                     '+
          // '    <div class="ms-Callout-inner">                                             '+
          // '        <div class="ms-Callout-content">                                       '+
          // '        <p class="ms-Callout-subText">'+ cell._cell.row.data.Overview +'</p>   '+
          // '        </div>                                                                 '+
          // '        <div class="ms-Callout-actions">                                       '+    
          // '        <a class="ms-Link" title="Learn More">View let</a>                     '+
          // '        </div>                                                                 '+
          // '    </div>                                                                     '+
          // '   </div>                                                                      '+
          // '</div>                                                                         '



          // Adds event listener to this cell, to activate callout
          cell._cell.element.addEventListener('click', function () {
            console.log(cell)
          });
          return "<a id='lettingCalloutButton'>View " + cell._cell.row.data.Title + " Details</a>";
        }



        // return "<em>Overview link</em><br><div>" + cell._cell.value + "</div>";
      },

    },

    {
      // Open Let in New tab link
      field: "OpenLet",
      title: "Details",
      responsive: 0,
      resizable: false,
      headerSort: false,
      download: false,
      width: 90,
      cssClass: "column_OpenLet",
      formatter: "link",
      formatterParams: {
        label: "Open Let",
        target: "_blank",
      }
    },
    {
      // View Let in panel    
      field: "ViewLet",
      width: 15,
      resizable: false,
      cssClass: "column_viewLet",
      headerSort: false,
      download: false,
      formatter: function (cell) {

        // Adds event listener to this cell, to activate Modal
        cell._cell.element.addEventListener('click', function () {

          var _link = cell._cell.row.data.OpenLet;

          // Pass it to a function that opens a modal
          loadAndOpenPanel(_link);
        });

        return "<i class='fa fa-slide'></i>";
      },
    }
    ],
    
    // Array of libraries we load at start
    lettingLibraries: [
      // "Central Letting",
      // "Division 1 Letting",
      // "Division 2 Letting",
      // "Division 3 Letting",
      // "Division 4 Letting",
      // "Division 5 Letting",
      // "Division 6 Letting",
      // "Division 7 Letting",
      // "Division 8 Letting",
      // "Division 9 Letting",
      // "Division 10 Letting",
      "Division 11 Letting",
      // "Division 12 Letting",
      // "Division 13 Letting",
      // "Division 14 Letting",
      // "Design Build Program",
      // "Roadside"
    ],

    // Array of Divisions passed in sorting
    divisionSortArray:[
      "Central",
      "Design Build",
      "Division 1",
      "Division 2",
      "Division 3",
      "Division 4",
      "Division 5",
      "Division 6",
      "Division 7",
      "Division 8",
      "Division 9",
      "Division 10",
      "Division 11",
      "Division 12",
      "Division 13",
      "Division 14",
      "Roadside"]
  },
  mutations: {
    // Adds an loaded let to the store
    ADD_LET(state, payload) {
      state.letDocSetItems.push(payload)
    },
    // change(state, rollUpColumns) {
    //   state.rollUpColumns = rollUpColumns
    // }
  },
  actions: {

  },
  getters: {
    letDocSetItems: state => state.letDocSetItems,
    rollUpColumns: state => state.rollUpColumns,
    divisionSortArray: state => state.divisionSortArray,
    lettingLibraries: state => state.lettingLibraries,
    lettingFields: state => state.lettingFields,
    lettingFieldsRoadside: state => state.lettingFieldsRoadside,
    lettingQuery: state => state.lettingQuery,
    lettingRoadsideQuery: state => state.lettingRoadsideQuery
  }
})
